export default __webpack_public_path__ + "static/media/todoapp.2efe2a79.jpeg";